import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import {
  BehaviorSubject,
  Observable,
  combineLatest,
  combineLatestAll,
  combineLatestWith,
  filter,
  map,
  of,
  scan,
  startWith,
} from 'rxjs';
import { NegotiationsService } from 'src/app/services/negotiations.service';
import { Negotiation } from './negotiations.model';
import { UserDetails } from '../login/user.model';
import { UserService } from 'src/app/services/user.service';
import { SocketService } from 'src/app/services/socket.service';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LotsService } from 'src/app/services/lots.service';
import { SeoService } from 'src/app/services/seo.service';
import { Analytics, logEvent } from '@angular/fire/analytics';
import { LogEventsEnum } from 'src/app/firebase.model';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { PriceTypePipe } from 'src/app/pipes/price-type.pipe';
import { LoadingSpinnerComponent } from '../custom/loading-spinner/loading-spinner.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatRippleModule, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';

@Component({
  selector: 'app-negotiations',
  templateUrl: './negotiations.component.html',
  styleUrls: ['./negotiations.component.css'],
  standalone: true,
  imports: [
    LoadingSpinnerComponent,
    CommonModule,
    RouterModule,
    FontAwesomeModule,
    FormsModule,
    ReactiveFormsModule,
    PriceTypePipe,
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatRadioModule,
    MatDialogModule,
    MatSnackBarModule,
    MatRippleModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSnackBarModule,
    MatCardModule,
    MatChipsModule,
    MatCheckboxModule,
    MatButtonToggleModule,
    MatSelectModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatDividerModule,
    MatIconModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatBottomSheetModule,
    MatMenuModule,
    MatBadgeModule,
  ],
})
export class NegotiationsComponent implements OnInit, OnDestroy {
  private analytics = inject(Analytics);
  isLoading: Boolean;
  userDetails: UserDetails;
  filteredNegotiations = new BehaviorSubject<Negotiation[]>(null);
  filteredNegotiations$ = this.filteredNegotiations.asObservable();
  negotiations$: Observable<Negotiation[]>;
  searchFilter = '';
  constructor(
    private negotiationsService: NegotiationsService,
    private userService: UserService,
    private socketService: SocketService,
    private lotsService: LotsService,
    private seoService: SeoService
  ) {}

  ngOnInit() {
    this.seoService.updateMetaTags([
      {
        name: 'description',
        content: 'List of active Negotiations for Bids and Offers',
      },
      { name: 'author', content: "Johnston's Connected" },
      { name: 'keywords', content: 'Acitve Negotiations' },
    ]);
    this.seoService.updateTitle('Negotiations Page');

    this.userDetails = this.userService.getUserDetails();
    // console.log("get user details",this.userDetails);
    this.isLoading = true;
    this.negotiations$ = this.negotiationsService
      .watch({ fetchPolicy: 'cache-and-network' })
      .valueChanges.pipe(
        map((result) => {
          logEvent(this.analytics, LogEventsEnum.negotiations_list_view);
          this.isLoading = false;
          this.filteredNegotiations.next(result.data.negotiations);
          // console.log(result)
          return result.data.negotiations;
        })
      );
    this.negotiations$.subscribe((negotiations) =>
      this.filteredNegotiations.next(negotiations)
    );
    // const negotiates$ = this.negotiationsService.watch({fetchPolicy: 'cache-and-network'}).valueChanges.pipe(
    //   map(result =>{
    //     this.isLoading = false;
    //     console.log(result)
    //     return result.data.negotiations
    //   })
    // );
    // const socketNegotiations$ = this.socketService.getSocketNegotiationObservable();

    // this.negotiations$ = negotiates$.pipe(
    //   combineLatestWith(socketNegotiations$.pipe(startWith(null))),
    //   map(([negotiations, socketNegotiations]) => {
    //     if (socketNegotiations) {
    //       negotiations.unshift(socketNegotiations);
    //     }
    //     return negotiations;
    //   }),
    //   // startWith(null)
    // );
  }

  filterList(event) {
    // console.log(event);
    // this.filteredLots$ = this.lots$;
    this.negotiations$.subscribe((lots) => {
      let filteredData: Negotiation[];
      if (event.selected) {
        if (event.source.ariaLabel == 'my-bids-offers') {
          filteredData = lots.filter(
            (e) => e.lot_user_id == this.userDetails._id
          );
        } else if (event.source.ariaLabel == 'my-negotiations') {
          filteredData = lots.filter((e) => e.user_id == this.userDetails._id);
        } else if (event.source.ariaLabel == 'Declined') {
          filteredData = lots.filter((e) => e.status == 'Declined');
        } else {
          filteredData = lots.filter(
            (e) => e.lot_type == event.source.ariaLabel
          );
        }
      } else {
        filteredData = lots;
      }
      this.filteredNegotiations.next(filteredData);
    });
  }

  searchList() {
    const searchValue = this.searchFilter.toLowerCase();

    this.negotiations$.subscribe((negotiations) => {
      const filtered = negotiations.filter((negotiation) => {
        // Adjust the conditions based on your negotiation model and search requirements
        return (
          (negotiation.price_value + '').toLowerCase().includes(searchValue) ||
          negotiation.commodity.toLowerCase().includes(searchValue) ||
          negotiation.destination.toLowerCase().includes(searchValue) ||
          negotiation.grade.toLowerCase().includes(searchValue)
          // Add more conditions if needed
          // ...
        );
      });

      this.filteredNegotiations.next(filtered);
    });
  }

  isSameYear(item): boolean {
    return (
      new Date(item.ship_begin).getFullYear() ===
      new Date(item.ship_end).getFullYear()
    );
  }

  ngOnDestroy(): void {
    // TODO
  }
}
